module.exports = __webpack_public_path__ + "img/img-estj.12a63e2f.jpg";